import { render, staticRenderFns } from "./EstimatedIdealExamVolume.vue?vue&type=template&id=9e62a324&scoped=true&"
import script from "./EstimatedIdealExamVolume.vue?vue&type=script&lang=js&"
export * from "./EstimatedIdealExamVolume.vue?vue&type=script&lang=js&"
import style0 from "./EstimatedIdealExamVolume.vue?vue&type=style&index=0&id=9e62a324&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e62a324",
  null
  
)

export default component.exports